import BaseAction from "../base-action";

class BaseSelect extends BaseAction {
    timelineMap;
    until;
    defaultAction;

    constructor(props = {}) {
        super(props);
        this.timelineMap = props.timelineMap || [];
        this.until = props.until || props.duration || 0;
        this.defaultAction = props.defaultAction || undefined;
    }

    hideTreesExcept(treeItem = "") {
        let hiddenTreeItems = ["treeViewData", "groupTreeView", "infoTagTreeView", "animationTreeView"];
        hiddenTreeItems.forEach(item => {
            if (treeItem === "" || item === treeItem) document.getElementById(item).style.display = 'block';
            else document.getElementById(item).style.display = 'none';
        });
    }
}

export default BaseSelect;